module.exports = __webpack_public_path__ + "static/media/ritualbanners_sm1.7da9de3e.png";